import { isMockMode, postBlast, simulateDelay } from "../../api";

export const getNodesForUser = ({ orgId }: { orgId: string }) => {
	if (isMockMode()) {
		const testData = {
			orgs: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
				},
			],
			users: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
			],
			nodeLibraries: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					type: 1,
					updateCount: 0,
					ownedByOrgId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					ownedByUserId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					lastUpdatedUtc: "2023-08-02T00:04:57.8886146Z",
					isDeleted: true,
					userCanAdmin: true,
					userCanWrite: true,
					isVisibleToOrg: true,
					isWritableByOrg: true,
				},
			],
		};
		return simulateDelay(50, () => testData);
	}

	return postBlast(`nodelibrary/getForUser`, { orgIds: [orgId] });
};
